import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Empty } from "Components/_Shared/Empty";
import { IconBadge } from "Components/_Shared/IconBadge";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly clientName: string;
};

export const ClientDetailError: React.FC<Props> = ({ clientName }) => {
  const { t } = useResource();

  return (
    <Empty
      icon={<IconBadge color="warning" icon={<WarningAmberOutlinedIcon sx={{ fontSize: 30 }} />} />}
      title={t(Resources.Clients.IncompleteMangoClient.Title, { client: clientName })}
      text={t(Resources.Clients.IncompleteMangoClient.Text)}
    />
  );
};
